<template>
  <div>
    <div class="sqheader p-2 m-1">
      <div class="heasub">{{ name }} ({{ counter.count }})</div>
      <div class="sqicon">
        <b-icon-plus
          font-scale="2"
          v-if="showplus"
          @click="
            showplus = false;
            showquest = true;
            showminus = true;
          "
          class="sqbicon"
        ></b-icon-plus>

        <b-icon-dash
          font-scale="2"
          v-if="showminus"
          @click="
            showquest = false;
            showminus = false;
            showplus = true;
          "
          class="sqbicon"
        ></b-icon-dash>
      </div>
    </div>
    <div class="sqbody" v-if="showquest">
      <tabler class="esq m-1 p-2" :datas="counter.data" :fields="counter.fields"></tabler>
    </div>
  </div>
</template>

<script>
import Tabler from "@/components/admin/Tabler";

export default {
  components: {
    Tabler,
  },
  props: {
    counter: Object,
    name: String,
  },
  data() {
    return {
      showplus: true,
      showminus: false,
      showquest: false,
    };
  },
  created(){
      window.MathJax = { MathML: { extensions: ["mml3.js", "content-mathml.js"]}};
      let externalScript = document.createElement('script')
      externalScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=MML_HTMLorMML')
      document.head.appendChild(externalScript)
  },
};
</script>

<style scoped>
.fhe {
  background-color: blue;
  color: white;
  border-radius: 20px 20px 0px 0px;
  font-weight: bold;
}

.detailsflex {
  display: flex;
}

.detailslabel {
  width: 35%;
  font-size: 1.1rem;
}

.detailsvalue {
  width: 65%;
  font-size: 1.2rem;
  font-weight: bolder;
}

.sqheader {
  font-size: 1.2rem;
  background-color: white;
  border-radius: 10px 10px;
  display: flex;
  font-weight: bold;
}

.heasub {
  width: 70%;
}

.sqicon {
  width: 30%;
  text-align: right;
  cursor: pointer;
}

.esq {
  border-radius: 10px 10px;
}

.form-rad {
}
</style>
